import { render, staticRenderFns } from "./AlertNameRS.vue?vue&type=template&id=6fe1bb2f&scoped=true&"
import script from "./AlertNameRS.vue?vue&type=script&lang=js&"
export * from "./AlertNameRS.vue?vue&type=script&lang=js&"
import style0 from "./AlertNameRS.vue?vue&type=style&index=0&id=6fe1bb2f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe1bb2f",
  null
  
)

export default component.exports